import { Button } from '@sunwebgroup/uds-ui/button'
import { IndeterminateProgressCircle } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { useIntl } from '@/intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import { useBookingDetailsStore } from '../../../infrastructure/useBookingDetailsStore'
import { getCanSavePreferences, getIsEditPreferencesLoading } from '../../selectors'
import { EDIT_PREFERENCES_FORM_ID, EditPreferencesForm } from './EditPreferencesForm'
import styles from './EditPreferencesSheet.module.css'

export function EditPreferencesSheet() {
  const { formatMessage } = useIntl()
  const { editPreferencesClosed } = useBookingDetailsActions()
  const isOpen = useBookingDetailsStore(state => state.editPreferences.isOpen)
  const submitStatus = useBookingDetailsStore(state => state.editPreferences.submitStatus)
  const canSavePreferences = useBookingDetailsStore(getCanSavePreferences)
  const isLoading = useBookingDetailsStore(getIsEditPreferencesLoading)
  const isSubmitting = submitStatus === 'loading'

  function handleOpenChange(open: boolean) {
    if (!open)
      editPreferencesClosed()
  }

  return (
    <Sheet.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Sheet.Body side="right">
        <Sheet.Header
          closeLabel={formatMessage({ id: 'close' })}
          titleLabel={formatMessage({ id: 'booking_details_preferences_edit_title' })}
        />
        <Sheet.Content className={isLoading ? styles.loadingSheetContent : undefined}>
          {isLoading ? <IndeterminateProgressCircle /> : <EditPreferencesForm />}
        </Sheet.Content>
        {!isLoading && (
          <Sheet.Footer>
            <Button
              type="submit"
              form={EDIT_PREFERENCES_FORM_ID}
              isLoading={isSubmitting}
              disabled={!canSavePreferences}
            >
              {formatMessage({ id: 'save_button_text' })}
            </Button>
          </Sheet.Footer>
        )}
      </Sheet.Body>
    </Sheet.Root>
  )
}
